import { GET, PATCH, POST_FILE } from './common/common.service'
import endpointsUsers from './users/endpoints'

const ProfileService = {
  getProfile: async () => GET(endpointsUsers.PROFILE),
  updateProfile: async (body) => PATCH(endpointsUsers.PROFILE, body),
  uploadImgProfile: async (file) => POST_FILE(endpointsUsers.PROFILE_IMG, file),
}

export default ProfileService
